// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s9VW3","field":"styles_field__2a6Y6","fieldCol":"styles_fieldCol__2IDlF","diffCol":"styles_diffCol__2OnDL","diff":"styles_diff__-9Snp"};